import React from "react";
import BotDetailsView from "./BotDetailsView";
import CommonModalPopUp from "../../../components/ui/Modals/ModalPopupCommon";


const BotModal = ({ bot, close, subscribeToBot, createConversation, ...rest }) => {
	if (!bot) return null;

	const handleSubscribeToBot = (botId) => {
		subscribeToBot(botId);
		close();
	};

	const handleCreateConversation = (bot) => {
		createConversation(bot);
		close();
	};

	return (
		<CommonModalPopUp onClose={close} noHeader>
			<BotDetailsView
				{...rest}
				bot={bot}
				subscribeToBot={handleSubscribeToBot}
				createConversation={handleCreateConversation}
			/>
		</CommonModalPopUp>
	);
};

export default BotModal;
